import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { ValidationMessage_default } from "./chunk-ZQDBVQVV.js";
import { TransitionComponent } from "./chunk-QUQRJRHE.js";
import { Link_default } from "./chunk-TK6RORJT.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { use_dismiss_default } from "./chunk-N3FBH5EY.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Alert/Alert.tsx
import { forwardRef, Fragment } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var ALERT_CLASSNAME_MAP = {
  variant: {
    error: "pd:bg-error-100",
    info: "pd:bg-info-100",
    dim: "pd:bg-dim-100",
    success: "pd:bg-success-100",
    warning: "pd:bg-warning-100"
  }
};
var Alert = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "info",
      isDismissible = false,
      dismissLabel,
      autoDismiss,
      onDismiss,
      role = "status",
      hasIcon = true,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "isDismissible", "dismissLabel", "autoDismiss", "onDismiss", "role", "hasIcon", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    isDismissed,
    handleDismiss
  } = use_dismiss_default(autoDismiss, onDismiss);
  return /* @__PURE__ */jsx(TransitionComponent, {
    as: Fragment,
    show: !isDismissed,
    variant: "appear-from-top",
    children: /* @__PURE__ */jsxs(ValidationMessage_default, __spreadProps(__spreadValues({
      ref,
      as: Component,
      variant,
      className: clsx("pd:alert", ALERT_CLASSNAME_MAP.variant[variant], className),
      role
    }, rest), {
      children: [hasIcon && /* @__PURE__ */jsx("span", {
        className: "pd:flex-none",
        children: /* @__PURE__ */jsx(ValidationIcon_default, {
          variant
        })
      }), /* @__PURE__ */jsx("div", {
        className: "pd:flex-1",
        children
      }), isDismissible &&
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      /* @__PURE__ */
      jsxs(Link_default, {
        as: "button",
        type: "button",
        variant: "inherit",
        className: "pd:flex-none",
        onClick: handleDismiss,
        children: [/* @__PURE__ */jsx("span", {
          className: "pd:sr-only",
          children: dismissLabel
        }), /* @__PURE__ */jsx(Icon_default, {
          icon: "times"
        })]
      })]
    }))
  });
});
var StoryAlert = args => /* @__PURE__ */jsx(Alert, __spreadValues({}, args));
var Alert_default = Alert;
export { ALERT_CLASSNAME_MAP, StoryAlert, Alert_default };